import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';

import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ThemeSet } from 'dashboard/models/theme-set';
import { ThemeSetsFilterParams } from 'dashboard/redux/thunk-actions/theme-sets';

interface ThemeSetsState {
  themeSets: ThemeSet[];
  filters: ThemeSetsFilterParams;
}
export const initialThemeSetsState: ThemeSetsState = {
  themeSets: [],
  filters: {
    omni: undefined,
    sortParams: { sort: 'updated_at', shouldSortDescending: true },
  },
};

const { reducer, actions } = createSlice<ThemeSetsState, SliceCaseReducers<ThemeSetsState>, string>(
  {
    name: 'theme-sets',
    initialState: initialThemeSetsState,
    reducers: {
      setThemeSets: (state, action: PayloadAction<ThemeSet[]>) => {
        state.themeSets = action.payload;
      },
      addThemeSet: (state, action: PayloadAction<ThemeSet>) => {
        state.themeSets = [action.payload, ...state.themeSets];
      },
      removeThemeSet: (state, action: PayloadAction<ThemeSet>) => {
        state.themeSets = state.themeSets.filter((themeSet) => themeSet.id !== action.payload.id);
      },
      setOmniSearch: (state, action: PayloadAction<string>) => {
        state.filters.omni = action.payload;
      },
      setSortParams: (state, action: PayloadAction<SortParams>) => {
        state.filters.sortParams = action.payload;
      },
    },
  },
);

export const { setThemeSets, addThemeSet, removeThemeSet, setOmniSearch, setSortParams } = actions;
export const themeSetsReducer = reducer;
